import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 8v12H2V10h20zm-6 6l-6-3.27v6.53L16 16z"
}), 'SubscriptionsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SubscriptionsSharp.js
// module id = 6571
// module chunks = 2